import commonDe from "./locales/de/common.json";
import v2De from "./locales/de/v2.json";
import commonEn from "./locales/en/common.json";
import v2En from "./locales/en/v2.json";
import commonEs from "./locales/es/common.json";
import v2Es from "./locales/es/v2.json";
import commonFr from "./locales/fr/common.json";
import v2Fr from "./locales/fr/v2.json";
import commonIt from "./locales/it/common.json";
import v2It from "./locales/it/v2.json";
import commonNl from "./locales/nl/common.json";
import v2Nl from "./locales/nl/v2.json";
import commonPt from "./locales/pt/common.json";
import v2Pt from "./locales/pt/v2.json";

export type DoChatLocale = "de" | "en" | "es" | "fr" | "it" | "nl" | "pt";

export type DoChatMessages = {
  "do-chat-v2": typeof v2Fr;
  "do-chat-common": typeof commonFr;
};

const messages: Record<DoChatLocale, DoChatMessages> = {
  de: { "do-chat-v2": v2De, "do-chat-common": commonDe },
  en: { "do-chat-v2": v2En, "do-chat-common": commonEn },
  es: { "do-chat-v2": v2Es, "do-chat-common": commonEs },
  fr: { "do-chat-v2": v2Fr, "do-chat-common": commonFr },
  it: { "do-chat-v2": v2It, "do-chat-common": commonIt },
  nl: { "do-chat-v2": v2Nl, "do-chat-common": commonNl },
  pt: { "do-chat-v2": v2Pt, "do-chat-common": commonPt },
};

const fallbackLocale: DoChatLocale = "fr";

/**
 * Returns next-intl compatible messages for the given locale.
 * Falls back to French if the locale is not supported.
 * Accepts full locale codes like "fr_FR" or "fr-FR" — only the first two chars are used.
 */
export function getDoChatMessages(locale: string): DoChatMessages {
  const normalized = locale.slice(0, 2).toLowerCase() as DoChatLocale;
  return messages[normalized] ?? messages[fallbackLocale];
}

export { commonDe, commonEn, commonEs, commonFr, commonIt, commonNl, commonPt };
export { v2De, v2En, v2Es, v2Fr, v2It, v2Nl, v2Pt };
